import React, { useState } from 'react';
import './search-box.scss';

type SearchBoxProps = {
  /** Fired on an explicit action (Tìm button / Enter) and on clear, with the
   *  trimmed query. NOT fired on every keystroke. */
  onSearch: (q: string) => void;
  /** Seed the input (e.g. the currently-applied query). Read once on mount. */
  initialValue?: string;
  placeholder?: string;
  /** Label on the submit button. */
  buttonLabel?: string;
  className?: string;
  autoFocus?: boolean;
};

/** Search input that applies the query only on an explicit action — clicking
 *  the "Tìm" button or pressing Enter — instead of live-filtering on every
 *  keystroke. Clearing (the × button) applies an empty query immediately. */
export const SearchBox: React.FC<SearchBoxProps> = ({
  onSearch,
  initialValue = '',
  placeholder = 'Tìm kiếm...',
  buttonLabel = 'Tìm',
  className = '',
  autoFocus = false,
}) => {
  const [value, setValue] = useState(initialValue);
  const submit = () => onSearch(value.trim());
  const clear = () => { setValue(''); onSearch(''); };

  return (
    <div className={`search-box ${className}`.trim()}>
      <div className="search-box__field">
        <i className="material-icons">search</i>
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          autoFocus={autoFocus}
          onChange={e => setValue(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); submit(); } }}
        />
        {value && (
          <button type="button" className="search-box__clear" onClick={clear} aria-label="Xóa tìm kiếm">
            <i className="material-icons">close</i>
          </button>
        )}
      </div>
      <button type="button" className="search-box__btn" onClick={submit}>
        <i className="material-icons">search</i>
        <span>{buttonLabel}</span>
      </button>
    </div>
  );
};

export default SearchBox;
